/******************************************************************************
 * Droits d'auteur (c) 2024 Niralakka
 *
 * La permission est accordée, gratuitement, à toute personne obtenant une copie de ce logiciel
 * et des fichiers de documentation associés (le "Logiciel"), de traiter le Logiciel sans restriction,
 * y compris, sans limitation, les droits d'utiliser, de copier, de modifier, de fusionner, de publier, de distribuer, de concéder
 * une sous-licence, et/ou de vendre des copies du Logiciel, et de permettre aux personnes à qui le Logiciel est fourni de le faire,
 * sous réserve des conditions suivantes :
 *
 * L'avis de droit d'auteur ci-dessus et cet avis d'autorisation doivent être inclus dans toutes les copies ou parties substantielles
 * du Logiciel.
 *
 * LE LOGICIEL EST FOURNI "TEL QUEL", SANS GARANTIE D'AUCUNE SORTE, EXPLICITE OU IMPLICITE,
 * Y COMPRIS, MAIS SANS S'Y LIMITER, LES GARANTIES DE QUALITÉ MARCHANDE, D'ADÉQUATION À UN USAGE PARTICULIER ET D'ABSENCE DE CONTREFAÇON.
 * EN AUCUN CAS LES AUTEURS OU LES TITULAIRES DES DROITS D'AUTEUR NE SERONT RESPONSABLES DE TOUTE RÉCLAMATION, DOMMAGES OU AUTRE RESPONSABILITÉ,
 * QUE CE SOIT DANS UNE ACTION DE CONTRAT, DE DÉLIT OU AUTRE, DÉCOULANT DE, HORS DE OU EN LIEN AVEC LE LOGICIEL OU L'UTILISATION
 * OU D'AUTRES TRANSACTIONS DANS LE LOGICIEL.
 *
 ******************************************************************************/

// Version: 2.0.0

import { NrlkAPI } from "./api.js";

/**
 * Classe modèle pour les appels HTTP relatifs aux utilisateurs (API V2).
 *
 * @param {string} entreprise - Slug de l'entreprise (header `Entreprise`)
 * @param {string|null} token - Jeton d'authentification (header `Token`)
 */
export class NrlkUtilisateur {
  constructor(entreprise, token = null) {
    this.api = new NrlkAPI(entreprise, token);
  }

  /**
   * Définit l'entreprise dans les headers de l'API.
   *
   * @param {string} entreprise
   */
  setEntreprise(entreprise) { this.api.setEntreprise(entreprise); }

  /**
   * Définit le token dans les headers de l'API.
   *
   * @param {string} token
   */
  setToken(token) { this.api.setToken(token); }

  /**
   * Récupère les données d'un utilisateur par son identifiant.
   *
   * @param {number} id - Identifiant de l'utilisateur
   * @returns {Promise<object>} Réponse brute de l'API (`utilisateur`)
   */
  async getUtilisateur(id) {
    return this.api.get(`/utilisateur/${id}`);
  }

  /**
   * Récupère la liste de tous les utilisateurs de l'entreprise.
   *
   * @returns {Promise<object>} Réponse brute de l'API (`utilisateur`)
   */
  async getUtilisateurs() {
    return this.api.get('/utilisateur/');
  }
}
